import { NgModule } from '@angular/core';

import { SpinnerComponent } from './spinner.component';
import { SpinnerRoutingModule } from './spinner.routing.module';

@NgModule({
  imports: [
    SpinnerRoutingModule
  ],
  exports: [
    SpinnerComponent
  ],
  declarations: [
    SpinnerComponent
  ]
})
export class SpinnerModule { }
